import { render, staticRenderFns } from "./proyectoLista.vue?vue&type=template&id=4bfd096f&"
import script from "./proyectoLista.vue?vue&type=script&lang=ts&"
export * from "./proyectoLista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports